export default __webpack_public_path__ + "static/media/events_card.61cf79f8.jpg";